import { Box, Stack, useTheme } from '@mui/material';
import {
  useAttendeeStatus,
  useRosterState,
} from 'amazon-chime-sdk-component-library-react';

import MicrophoneIcon from '../icons/microphoneIcon';
import VideoCameraIcon from '../icons/videoCameraIcon';

interface AttendeeCellProps {
  attendeeID: string;
}

function AttendeeCell({ attendeeID }: AttendeeCellProps) {
  const theme = useTheme();
  const { muted, videoEnabled } = useAttendeeStatus(attendeeID);
  const { roster } = useRosterState();
  const attendeeName = roster[attendeeID]?.name || '';

  return (
    <Stack direction='row' justifyContent='space-between'>
      <Box>{attendeeName}</Box>
      <Stack direction='row' gap={1}>
        <Box>
          <MicrophoneIcon
            muted={muted}
            color={muted ? '#4F4F4F' : theme.palette.teal.main}
          />
        </Box>
        <Box>
          <VideoCameraIcon videoEnabled={videoEnabled} color='#4F4F4F' />
        </Box>
      </Stack>
    </Stack>
  );
}

export default AttendeeCell;
